var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_29-auction",
    "data-name": "29-auction",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.459,
    height: 26.917,
    viewBox: "0 0 26.459 26.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25718",
    "data-name": "Path 25718",
    d: "M0,88H15.565v2.224H0Z",
    transform: "translate(0 -63.306)",
    fill: "#4f505f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25719",
    "data-name": "Path 25719",
    d: "M19.118,77.047a1.112,1.112,0,0,0-1.112-1.112H9.112A1.112,1.112,0,0,0,8,77.047v1.13H19.118Z",
    transform: "translate(-5.776 -54.595)",
    fill: "#4f505f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25720",
    "data-name": "Path 25720",
    d: "M51.076,43.887a7.756,7.756,0,0,0-1.289,1.855l9.151,9.151a1.112,1.112,0,0,0,1.572,0l1.572-1.572a1.112,1.112,0,0,0,0-1.572L52.931,42.6A7.578,7.578,0,0,0,51.076,43.887Z",
    transform: "translate(-35.949 -30.525)",
    fill: "#4f505f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25721",
    "data-name": "Path 25721",
    d: "M27.161,19.972a9.641,9.641,0,0,1-2.874,1.842l5.746,5.746a9.8,9.8,0,0,1,1.845-2.873,9.649,9.649,0,0,1,2.874-1.843L29.006,17.1A9.806,9.806,0,0,1,27.161,19.972Z",
    transform: "translate(-17.537 -12.112)",
    fill: "#4f505f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12685",
    "data-name": "Rectangle 12685",
    width: 4.447,
    height: 11.118,
    rx: 2.224,
    transform: "translate(11.195 3.144) rotate(-45)",
    fill: "#4f505f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12686",
    "data-name": "Rectangle 12686",
    width: 4.447,
    height: 11.118,
    rx: 2.224,
    transform: "translate(1.761 12.576) rotate(-45)",
    fill: "#4f505f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.7020f12a55c349ec443405d648eff931.svg";
export { ForwardRef as ReactComponent };